module.exports = __webpack_public_path__ + "static/media/i was ordinary.8de40d65.png";